var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"src":_vm.animationUrl,"controls":""}}),_c('b-img-lazy',{attrs:{"src":_vm.uri,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }